import { render, staticRenderFns } from "./button-hold-to-confirm.vue?vue&type=template&id=7b8d43a8"
import script from "./button-hold-to-confirm.vue?vue&type=script&lang=js"
export * from "./button-hold-to-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8d43a8')) {
      api.createRecord('7b8d43a8', component.options)
    } else {
      api.reload('7b8d43a8', component.options)
    }
    module.hot.accept("./button-hold-to-confirm.vue?vue&type=template&id=7b8d43a8", function () {
      api.rerender('7b8d43a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/button-hold-to-confirm.vue"
export default component.exports